// this file is automatically generated by git.version.ts script
export const versions = {version: '1.0.0', revision: '8dcca2302b280378e46ad22c984b57d7aec0675c', branch: 'HEAD'};